import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import { AISidebar, AIRecommendationPanel } from '../components/ai';
import { AIOutlineButton } from '../components/ui/AIOutlineButton';
import { exportToCSV, formatDateForCSV } from '../utils/exportCSV';
import { Plus, Search, Filter, MoreVertical, Edit, Copy, Pause, Play, Gift, Download, Calendar, MessageCircle, SkipBack, ArrowUpDown, Gem, ChevronDown } from 'lucide-react';
// Mock rewards data - Prodotti La Saponaria with working placeholder images
const mockRewards = [{
  id: 1,
  code: 'SIERO-HA-001',
  name: 'Siero Acido Ialuronico Multi-Peso',
  type: 'Prodotto Viso',
  status: 'Attivo',
  cost: 50,
  image: 'https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=200&h=200&fit=crop',
  availability: {
    current: 45,
    total: 100
  },
  redemptionsPeriod: 28,
  redemptionsTotal: 234,
  lastRedemption: '2 ore fa',
  location: 'Milano Centro',
  startDate: '2026-03-01',
  endDate: '2026-12-31',
  aiHint: null
}, {
  id: 2,
  code: 'SOLIDI-KIT-002',
  name: 'Kit Cosmetici Solidi Zero Waste',
  type: 'Cosmetici Solidi',
  status: 'Attivo',
  cost: 50,
  image: 'https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=200&h=200&fit=crop',
  availability: {
    current: 12,
    total: 50
  },
  redemptionsPeriod: 22,
  redemptionsTotal: 187,
  lastRedemption: '5 ore fa',
  location: 'Roma Cola di Rienzo',
  startDate: '2026-03-15',
  endDate: '2026-08-30',
  aiHint: {
    text: 'Disponibilità bassa: aumenta stock del 40%',
    explanation: 'Basato su 187 riscatti totali e trend crescente (+25%), questo premio sta per esaurirsi. I cosmetici solidi zero-waste sono molto richiesti.'
  }
}, {
  id: 3,
  code: 'CREMA-VISO-003',
  name: 'Crema Viso Deep Care Anti-Age',
  type: 'Prodotto Viso',
  status: 'Inattivo',
  cost: 50,
  image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=200&h=200&fit=crop',
  availability: {
    current: 28,
    total: 80
  },
  redemptionsPeriod: 18,
  redemptionsTotal: 156,
  lastRedemption: '1 giorno fa',
  location: 'Bologna',
  startDate: '2026-04-01',
  endDate: null,
  aiHint: null
}, {
  id: 4,
  code: 'HENNE-004',
  name: 'Set Hennetica Tinte Vegetali',
  type: 'Prodotto Capelli',
  status: 'Attivo',
  cost: 60,
  image: 'https://images.unsplash.com/photo-1522338242992-e1a54906a8da?w=200&h=200&fit=crop',
  availability: {
    current: 23,
    total: 60
  },
  redemptionsPeriod: 15,
  redemptionsTotal: 142,
  lastRedemption: '3 ore fa',
  location: 'Milano Solari',
  startDate: null,
  endDate: '2026-12-31',
  aiHint: {
    text: 'Prova ad abbassare il costo di 10 punti per aumentare i riscatti',
    explanation: 'I premi nella fascia 45-55 punti hanno un tasso di conversione 18% più alto. Questo premio ha performance sotto la media per la sua categoria.'
  }
}, {
  id: 5,
  code: 'WORK-005',
  name: 'Workshop Cosmetici Fai-da-Te',
  type: 'Esperienza',
  status: 'Programmato',
  cost: 100,
  image: 'https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=200&h=200&fit=crop',
  availability: {
    current: 15,
    total: 15
  },
  redemptionsPeriod: 0,
  redemptionsTotal: 0,
  lastRedemption: 'Mai',
  location: 'Pesaro (Sede)',
  startDate: '2026-05-01',
  endDate: '2026-08-30',
  aiHint: null
}, {
  id: 6,
  code: 'VOUCHER-20',
  name: 'Buono Sconto 20€ su Acquisto',
  type: 'Buono Sconto',
  status: 'Scaduto',
  cost: 40,
  image: 'https://images.unsplash.com/photo-1607083206968-13611e3d76db?w=200&h=200&fit=crop',
  availability: {
    current: 0,
    total: 0,
    unlimited: true
  },
  redemptionsPeriod: 45,
  redemptionsTotal: 312,
  lastRedemption: '1 ora fa',
  location: 'Tutte le Sedi',
  startDate: null,
  endDate: null,
  aiHint: null
}, {
  id: 7,
  code: 'CORPO-AHA-007',
  name: 'Crema Corpo AHA Levigante',
  type: 'Prodotto Corpo',
  status: 'Attivo',
  cost: 45,
  image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=200&h=200&fit=crop',
  availability: {
    current: 34,
    total: 70
  },
  redemptionsPeriod: 12,
  redemptionsTotal: 98,
  lastRedemption: '6 ore fa',
  location: 'Firenze',
  startDate: '2026-03-10',
  endDate: '2026-12-31',
  aiHint: null
}, {
  id: 8,
  code: 'BOX-BIO-008',
  name: 'Box Scoperta Prodotti Bio',
  type: 'Kit Prodotti',
  status: 'Inattivo',
  cost: 70,
  image: 'https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=200&h=200&fit=crop',
  availability: {
    current: 8,
    total: 30
  },
  redemptionsPeriod: 0,
  redemptionsTotal: 67,
  lastRedemption: '3 giorni fa',
  location: 'Torino',
  startDate: '2026-03-01',
  endDate: '2026-05-31',
  aiHint: null
}];
const Rewards = () => {
  const navigate = useNavigate();
  const [rewards, setRewards] = useState(mockRewards);
  const [filteredRewards, setFilteredRewards] = useState(mockRewards);
  const [statusFilter, setStatusFilter] = useState('Tutti');
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [openMenuId, setOpenMenuId] = useState<number | null>(null);
  const [isAISidebarOpen, setIsAISidebarOpen] = useState(false);
  const [hoveredAITip, setHoveredAITip] = useState<number | null>(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState<{
    key: string | null;
    direction: 'asc' | 'desc' | null;
  }>({
    key: null,
    direction: null
  });
  const [toast, setToast] = useState<{
    message: string;
    show: boolean;
  }>({
    message: '',
    show: false
  });
  const tooltipRef = useRef<HTMLDivElement>(null);
  const statusDropdownRef = useRef<HTMLDivElement>(null);
  // Close status dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target as Node)) {
        setIsStatusDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    let result = [...mockRewards];
    if (statusFilter !== 'Tutti') {
      result = result.filter(reward => reward.status === statusFilter);
    }
    if (searchTerm) {
      result = result.filter(reward => reward.name.toLowerCase().includes(searchTerm.toLowerCase()));
    }
    // Date filtering
    if (dateFrom) {
      result = result.filter(reward => {
        if (!reward.startDate) return true;
        return new Date(reward.startDate) >= new Date(dateFrom);
      });
    }
    if (dateTo) {
      result = result.filter(reward => {
        if (!reward.endDate) return true;
        return new Date(reward.endDate) <= new Date(dateTo);
      });
    }
    // Sorting
    if (sortConfig.key && sortConfig.direction) {
      result.sort((a: any, b: any) => {
        let aValue = a[sortConfig.key!];
        let bValue = b[sortConfig.key!];
        // Handle special cases
        if (sortConfig.key === 'availability') {
          aValue = a.availability.current;
          bValue = b.availability.current;
        } else if (sortConfig.key === 'redemptions') {
          aValue = calculateRedeemed(a);
          bValue = calculateRedeemed(b);
        } else if (sortConfig.key === 'startDate' || sortConfig.key === 'endDate') {
          aValue = aValue ? new Date(aValue).getTime() : 0;
          bValue = bValue ? new Date(bValue).getTime() : 0;
        }
        if (aValue < bValue) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    setFilteredRewards(result);
  }, [statusFilter, searchTerm, dateFrom, dateTo, sortConfig]);
  const handleSort = (key: string) => {
    let direction: 'asc' | 'desc' | null = 'asc';
    if (sortConfig.key === key) {
      if (sortConfig.direction === 'asc') {
        direction = 'desc';
      } else if (sortConfig.direction === 'desc') {
        direction = null;
      }
    }
    setSortConfig({
      key: direction ? key : null,
      direction
    });
  };
  const handleCreateReward = () => {
    navigate('/rewards/new');
  };
  const handleExportCSV = () => {
    // Prepare data for CSV export
    const csvData = filteredRewards.map(reward => ({
      'Nome Premio': reward.name,
      Codice: reward.code,
      Stato: reward.status,
      Costo: reward.cost,
      Riscattati: calculateRedeemed(reward),
      Rimanenti: reward.availability.unlimited ? 'Illimitato' : reward.availability.current,
      Inizio: formatDateForCSV(reward.startDate),
      Fine: formatDateForCSV(reward.endDate)
    }));
    const headers = ['Nome Premio', 'Codice', 'Stato', 'Costo', 'Riscattati', 'Rimanenti', 'Inizio', 'Fine'];
    exportToCSV(csvData, 'GB_Partner.csv', headers);
    showToast('Esportazione CSV completata');
  };
  const handleRowClick = (rewardId: number) => {
    navigate(`/rewards/${rewardId}`);
  };
  const handleToggleStatus = (rewardId: number, currentStatus: string) => {
    const newStatus = currentStatus === 'Attivo' ? 'Inattivo' : currentStatus === 'Inattivo' ? 'Attivo' : currentStatus;
    setRewards(prev => prev.map(r => r.id === rewardId ? {
      ...r,
      status: newStatus
    } : r));
    showToast('Premio aggiornato');
    setOpenMenuId(null);
  };
  const handleDuplicate = (rewardId: number) => {
    showToast('Premio duplicato');
    setOpenMenuId(null);
  };
  const showToast = (message: string) => {
    setToast({
      message,
      show: true
    });
    setTimeout(() => {
      setToast({
        message: '',
        show: false
      });
    }, 3000);
  };
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'Attivo':
        return <Play className="h-4 w-4 text-green-600" data-id="element-1776" />;
      case 'Programmato':
        return <Calendar className="h-4 w-4 text-blue-600" data-id="element-1777" />;
      case 'Inattivo':
        return <Pause className="h-4 w-4 text-amber-600" data-id="element-1778" />;
      case 'Scaduto':
        return <SkipBack className="h-4 w-4 text-gray-600" data-id="element-1779" />;
      default:
        return null;
    }
  };
  const getStatusLabel = (status: string) => {
    return status;
  };
  const statusOptions = [{
    value: 'Tutti',
    label: 'Tutti gli stati',
    icon: null
  }, {
    value: 'Attivo',
    label: 'Attivo',
    icon: <Play className="h-4 w-4 text-green-600" data-id="element-1780" />
  }, {
    value: 'Programmato',
    label: 'Programmato',
    icon: <Calendar className="h-4 w-4 text-blue-600" data-id="element-1781" />
  }, {
    value: 'Inattivo',
    label: 'Inattivo',
    icon: <Pause className="h-4 w-4 text-amber-600" data-id="element-1782" />
  }, {
    value: 'Scaduto',
    label: 'Scaduto',
    icon: <SkipBack className="h-4 w-4 text-gray-600" data-id="element-1783" />
  }];
  const selectedStatusOption = statusOptions.find(opt => opt.value === statusFilter) || statusOptions[0];
  const formatDate = (dateString: string | null) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };
  const calculateRedeemed = (reward: any) => {
    if (reward.availability.unlimited) return reward.redemptionsTotal;
    return reward.availability.total - reward.availability.current;
  };
  const SortableHeader = ({
    label,
    sortKey,
    className = ''
  }: {
    label: string;
    sortKey: string;
    className?: string;
  }) => {
    const isSorted = sortConfig.key === sortKey;
    return <th className={`px-4 py-3 cursor-pointer select-none ${className}`} onClick={() => handleSort(sortKey)} data-id="element-1784">
        <div className="flex items-center justify-between whitespace-nowrap" data-id="element-1785">
          <span data-id="element-1786">{label}</span>
          <ArrowUpDown className={`h-3 w-3 ml-1 ${isSorted ? 'text-green-600' : 'text-gray-400'}`} data-id="element-1787" />
        </div>
      </th>;
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-1788">
      {/* Desktop Sidebar Wrapper - Hidden on Mobile */}
      <div className="hidden lg:block w-20 flex-shrink-0" data-id="element-1789">
        <Sidebar data-id="element-1790" />
      </div>

      {/* Mobile Sidebar - Overlay */}
      <div className="lg:hidden" data-id="element-1791">
        <Sidebar mobileOpen={sidebarOpen} onMobileClose={() => setSidebarOpen(false)} data-id="element-1792" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-1793">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-1794" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-1795">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-4" data-id="element-1796">
            <div data-id="element-1797">
              <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1798">Premi</h1>
              <p className="text-sm text-gray-500 mt-1" data-id="element-1799">
                Crea e gestisci le offerte disponibili per gli utenti.
              </p>
            </div>
            <div className="flex items-center gap-3" data-id="element-1800">
              <AIOutlineButton onClick={() => setIsAISidebarOpen(true)} title="AI Insights" data-id="element-1801">
                Suggerimenti AI
              </AIOutlineButton>
              <button onClick={handleCreateReward} className="inline-flex items-center px-4 py-2 bg-greenback text-white text-sm font-medium hover:bg-greenback-600 transition-colors" style={{
              borderRadius: '100px'
            }} data-id="element-1802">
                <Plus className="h-4 w-4 mr-2" data-id="element-1803" />
                Crea Premio
              </button>
            </div>
          </div>

          {/* Filters */}
          <div className="mb-6 flex flex-wrap gap-3 items-center" data-id="element-1804">
            <div className="relative w-full sm:w-auto" data-id="element-1805">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" data-id="element-1806" />
              <input type="text" placeholder="Cerca premio..." className="w-full sm:w-auto rounded-lg border border-gray-300 pl-10 pr-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-greenback" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1807" />
            </div>

            {/* Date From */}
            <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2 gap-2 w-full sm:w-auto" data-id="element-1808">
              <Calendar className="h-4 w-4 text-gray-500" data-id="element-1809" />
              <span className="text-sm text-gray-600 whitespace-nowrap" data-id="element-1810">
                Da:
              </span>
              <input type="date" className="bg-transparent text-sm focus:outline-none w-full" value={dateFrom} onChange={e => setDateFrom(e.target.value)} data-id="element-1811" />
            </div>

            {/* Date To */}
            <div className="flex items-center rounded-lg border border-gray-300 px-3 py-2 gap-2 w-full sm:w-auto" data-id="element-1812">
              <Calendar className="h-4 w-4 text-gray-500" data-id="element-1813" />
              <span className="text-sm text-gray-600 whitespace-nowrap" data-id="element-1814">
                A:
              </span>
              <input type="date" className="bg-transparent text-sm focus:outline-none w-full" value={dateTo} onChange={e => setDateTo(e.target.value)} data-id="element-1815" />
            </div>

            {/* Custom Status Dropdown */}
            <div className="relative w-full sm:w-auto" ref={statusDropdownRef} data-id="element-1816">
              <button onClick={() => setIsStatusDropdownOpen(!isStatusDropdownOpen)} className="w-full sm:w-auto flex items-center justify-between sm:justify-start rounded-lg border border-gray-300 px-3 py-2 gap-2 hover:bg-gray-50 transition-colors" data-id="element-1817">
                <div className="flex items-center gap-2" data-id="element-1818">
                  <Filter className="h-4 w-4 text-gray-500" data-id="element-1819" />
                  {selectedStatusOption.icon && <span className="flex items-center" data-id="element-1820">
                      {selectedStatusOption.icon}
                    </span>}
                  <span className="text-sm text-gray-700" data-id="element-1821">
                    {selectedStatusOption.label}
                  </span>
                </div>
                <ChevronDown className="h-4 w-4 text-gray-500" data-id="element-1822" />
              </button>

              {isStatusDropdownOpen && <div className="absolute top-full left-0 mt-1 w-full sm:w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-1823">
                  {statusOptions.map(option => <button key={option.value} onClick={() => {
                setStatusFilter(option.value);
                setIsStatusDropdownOpen(false);
              }} className={`w-full flex items-center gap-2 px-3 py-2 text-sm text-left hover:bg-gray-50 transition-colors ${statusFilter === option.value ? 'bg-gray-50' : ''} ${option.value === statusOptions[0].value ? 'rounded-t-lg' : ''} ${option.value === statusOptions[statusOptions.length - 1].value ? 'rounded-b-lg' : ''}`} data-id="element-1824">
                      {option.icon ? <span className="flex items-center" data-id="element-1825">{option.icon}</span> : <span className="w-4" data-id="element-1826"></span>}
                      <span className="text-gray-700" data-id="element-1827">{option.label}</span>
                    </button>)}
                </div>}
            </div>

            {/* Esporta CSV - Tertiary Button (text-only, right-aligned) */}
            <button onClick={handleExportCSV} className="ml-auto text-sm text-gray-600 hover:text-gray-900 hover:underline transition-colors inline-flex items-center gap-1.5" data-id="element-1828">
              <Download className="h-4 w-4" data-id="element-1829" />
              Esporta CSV
            </button>
          </div>

          {/* Table or Empty State */}
          {filteredRewards.length > 0 ? <div className="rounded-lg border border-gray-200 bg-white overflow-hidden" data-id="element-1830">
              <div className="overflow-x-auto" data-id="element-1831">
                <table className="w-full" data-id="element-1832">
                  <thead data-id="element-1833">
                    <tr className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1834">
                      <th className="px-4 py-3" data-id="element-1835">Immagine</th>
                      <SortableHeader label="Nome Premio" sortKey="name" className="min-w-[160px]" data-id="element-1836" />
                      <SortableHeader label="Codice" sortKey="code" data-id="element-1837" />
                      <SortableHeader label="Stato" sortKey="status" data-id="element-1838" />
                      <SortableHeader label="Costo" sortKey="cost" data-id="element-1839" />
                      <SortableHeader label="Riscattati" sortKey="redemptions" data-id="element-1840" />
                      <SortableHeader label="Rimanenti" sortKey="availability" data-id="element-1841" />
                      <SortableHeader label="Inizio" sortKey="startDate" data-id="element-1842" />
                      <SortableHeader label="Fine" sortKey="endDate" data-id="element-1843" />
                      <th className="px-4 py-3 whitespace-nowrap" data-id="element-1844">AI Tips</th>
                      <th className="px-4 py-3" data-id="element-1845">Azioni</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-1846">
                    {filteredRewards.map(reward => <tr key={reward.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => handleRowClick(reward.id)} data-id="element-1847">
                        <td className="px-4 py-4" data-id="element-1848">
                          <img src={reward.image} alt={reward.name} className="h-16 w-16 rounded-lg object-cover" data-id="element-1849" />
                        </td>
                        <td className="px-4 py-4" style={{
                    minWidth: '160px'
                  }} data-id="element-1850">
                          <div className="font-medium text-gray-900" data-id="element-1851">
                            {reward.name}
                          </div>
                        </td>
                        <td className="px-4 py-4" data-id="element-1852">
                          <span className="font-mono text-sm text-gray-700" data-id="element-1853">
                            {reward.code}
                          </span>
                        </td>
                        <td className="px-4 py-4" data-id="element-1854">
                          <div className="inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 cursor-help group" title={getStatusLabel(reward.status)} data-id="element-1855">
                            {getStatusIcon(reward.status)}
                          </div>
                        </td>
                        <td className="px-4 py-4 font-medium" data-id="element-1856">
                          <div className="flex items-center gap-1" data-id="element-1857">
                            <Gem className="h-3.5 w-3.5 text-gray-500" data-id="element-1858" />
                            <span data-id="element-1859">{reward.cost}</span>
                          </div>
                        </td>
                        <td className="px-4 py-4 font-medium" data-id="element-1860">
                          {calculateRedeemed(reward)}
                        </td>
                        <td className="px-4 py-4" data-id="element-1861">
                          {reward.availability.unlimited ? <span className="text-gray-600" data-id="element-1862">∞</span> : <span className="font-medium" data-id="element-1863">
                              {reward.availability.current}
                            </span>}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-600" data-id="element-1864">
                          {formatDate(reward.startDate)}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-600" data-id="element-1865">
                          {formatDate(reward.endDate)}
                        </td>
                        <td className="px-4 py-4" data-id="element-1866">
                          {reward.aiHint ? <div className="relative inline-block" onMouseEnter={() => setHoveredAITip(reward.id)} onMouseLeave={() => setHoveredAITip(null)} onClick={e => e.stopPropagation()} data-id="element-1867">
                              <div style={{
                        background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%)',
                        padding: '1px',
                        borderRadius: '50%',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer'
                      }} data-id="element-1868">
                                <div style={{
                          background: 'white',
                          borderRadius: '50%',
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }} data-id="element-1869">
                                  <MessageCircle className="h-4 w-4 text-purple-600" data-id="element-1870" />
                                </div>
                              </div>

                              {hoveredAITip === reward.id && <div ref={tooltipRef} className="absolute z-50 w-64" style={{
                        bottom: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        marginBottom: '8px'
                      }} data-id="element-1871">
                                  <div style={{
                          background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%)',
                          padding: '1px',
                          borderRadius: '8px'
                        }} data-id="element-1872">
                                    <div className="p-3 bg-white rounded-lg shadow-xl" data-id="element-1873">
                                      <div className="text-xs font-semibold text-gray-900 mb-1" data-id="element-1874">
                                        {reward.aiHint.text}
                                      </div>
                                      <div className="text-xs text-gray-600" data-id="element-1875">
                                        {reward.aiHint.explanation}
                                      </div>
                                    </div>
                                  </div>
                                  <div style={{
                          position: 'absolute',
                          bottom: '-5px',
                          left: '50%',
                          marginLeft: '-4px',
                          width: '8px',
                          height: '8px',
                          background: 'linear-gradient(135deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%)',
                          transform: 'rotate(45deg)'
                        }} data-id="element-1876" />
                                </div>}
                            </div> : <span className="text-xs text-gray-400" data-id="element-1877">-</span>}
                        </td>
                        <td className="px-4 py-4" data-id="element-1878">
                          <div className="relative" data-id="element-1879">
                            <button onClick={e => {
                        e.stopPropagation();
                        setOpenMenuId(openMenuId === reward.id ? null : reward.id);
                      }} className="p-1 hover:bg-gray-100 rounded" data-id="element-1880">
                              <MoreVertical className="h-5 w-5 text-gray-500" data-id="element-1881" />
                            </button>

                            {openMenuId === reward.id && <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-10" data-id="element-1882">
                                <button onClick={e => {
                          e.stopPropagation();
                          handleRowClick(reward.id);
                        }} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center" data-id="element-1883">
                                  <Edit className="h-4 w-4 mr-2" data-id="element-1884" />
                                  Modifica
                                </button>
                                <button onClick={e => {
                          e.stopPropagation();
                          handleToggleStatus(reward.id, reward.status);
                        }} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center" disabled={reward.status === 'Scaduto' || reward.status === 'Programmato'} data-id="element-1885">
                                  {reward.status === 'Attivo' ? <>
                                      <Pause className="h-4 w-4 mr-2" data-id="element-1886" />
                                      Disattiva
                                    </> : <>
                                      <Play className="h-4 w-4 mr-2" data-id="element-1887" />
                                      Attiva
                                    </>}
                                </button>
                                <button onClick={e => {
                          e.stopPropagation();
                          handleDuplicate(reward.id);
                        }} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center border-t border-gray-100" data-id="element-1888">
                                  <Copy className="h-4 w-4 mr-2" data-id="element-1889" />
                                  Duplica
                                </button>
                              </div>}
                          </div>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div> : <div className="rounded-lg border border-gray-200 bg-white p-12" data-id="element-1890">
              <div className="text-center" data-id="element-1891">
                <Gift className="h-16 w-16 text-gray-300 mx-auto mb-4" data-id="element-1892" />
                <h2 className="text-xl font-semibold text-gray-700 mb-2" data-id="element-1893">
                  Nessun premio ancora
                </h2>
                <p className="text-gray-500 max-w-md mx-auto mb-6" data-id="element-1894">
                  Crea il tuo primo premio per permettere agli utenti di
                  riscattare con i punti.
                </p>
                <button onClick={handleCreateReward} className="inline-flex items-center px-4 py-2 bg-greenback text-white rounded-lg hover:bg-greenback-600 transition-colors" data-id="element-1895">
                  <Plus className="h-4 w-4 mr-2" data-id="element-1896" />
                  Crea Premio
                </button>
              </div>
            </div>}
        </main>
      </div>

      {/* AI Sidebar */}
      <AISidebar isOpen={isAISidebarOpen} onClose={() => setIsAISidebarOpen(false)} title="Suggerimenti AI per i tuoi premi" data-id="element-1897">
        <AIRecommendationPanel recommendations={[{
        id: '1',
        title: 'Set Attivi Puri (Fitoretinolo + Collagene)',
        type: 'Prodotto Viso',
        diamondRange: '60-70 punti',
        reason: 'Trend in crescita: prodotti anti-age naturali +22%. Alta domanda per attivi concentrati e personalizzabili.',
        ctaLabel: 'Crea premio da qui',
        onCtaClick: () => navigate('/rewards/new')
      }, {
        id: '2',
        title: 'Ottimizza "Kit Cosmetici Solidi"',
        type: 'Ottimizzazione',
        diamondRange: '45 punti (da 50)',
        reason: 'Disponibilità bassa (12/50) e trend +25%. Riduci costo di 5 punti per aumentare accessibilità e velocizzare rotazione stock.',
        ctaLabel: 'Duplica e modifica',
        onCtaClick: () => {
          showToast('Premio duplicato con modifiche suggerite');
          setTimeout(() => navigate('/rewards/new'), 1000);
        }
      }]} data-id="element-1898" />
      </AISidebar>

      {/* Toast Notification */}
      {toast.show && <div className="fixed bottom-6 right-6 bg-gray-900 text-white px-6 py-3 rounded-lg shadow-lg z-50 animate-fade-in" data-id="element-1899">
          {toast.message}
        </div>}
    </div>;
};
export default Rewards;